module.exports = __webpack_public_path__ + "media/images/close-modal-icon-75268cc1a27431108e797f926d6646c6.png";